import firebase from 'firebase';
import { useCollectionData } from 'react-firebase-hooks/firestore';

import { db } from './firebase';
import { FIRESTORE_FIELDS, FIRESTORE_KEYS } from '../utils/constants';

export default function useEventService() {
  const {DESC} = FIRESTORE_FIELDS
  const {EVENTS} = FIRESTORE_KEYS
  const eventTypesList = Object.freeze([
    { id: 1, name: 'Homework', hex: '#735BF2' },
    { id: 2, name: 'Test', hex: '#00B383' },
    { id: 3, name: 'Project', hex: '#0095FF' },
    { id: 4, name: 'Subject', hex: '#FF4747' },
    { id: 5, name: 'Event', hex: '#FFC400' },
    { id: 6, name: 'Meeting', hex: '#FF00B8' },
    { id: 6, name: 'Only Me', hex: '#FF4A4A' },
  ]);

  const useGetEvents = () => {
    const [eventList] = useCollectionData(
      firebase.firestore().collection(EVENTS).orderBy('date', DESC),
      { idField: 'id' }
    );
    return { eventList };
  };

  const createEvent = (data) => db.collection(EVENTS).add(data);

  const updateEvent = (eventId, data) => db.collection(EVENTS).doc(eventId).update(data);

  const deleteEvent = (id) => db.collection(EVENTS).doc(id).delete();

  return { createEvent, updateEvent, deleteEvent, useGetEvents, eventTypesList };
}
